if (!window.productGridLoadMoreInitialized) {
  window.productGridLoadMoreInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-product-grid-load-more]');

    if (
      !button ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();

    if (button.getAttribute('aria-busy') === 'true') return;

    const nextUrl = new URL(button.href, window.location.origin);
    nextUrl.searchParams.delete('section_id');

    const productGridContainer = button.closest('#ProductGridContainer');
    const productGrid = productGridContainer?.querySelector('#product-grid');

    if (!productGrid) {
      window.location.assign(nextUrl.href);
      return;
    }

    setLoading(button, true);

    try {
      const response = await fetch(nextUrl.href);
      if (!response.ok) throw new Error(`Load More request failed with status ${response.status}`);

      const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextProductGrid = responseDocument.querySelector('#product-grid');

      if (!nextProductGrid) throw new Error('Load More response did not contain a product grid');

      productGrid.insertAdjacentHTML('beforeend', nextProductGrid.innerHTML);

      const nextButton = responseDocument.querySelector('[data-product-grid-load-more]');
      if (nextButton) {
        button.href = new URL(nextButton.getAttribute('href'), nextUrl.origin).href;
        setLoading(button, false);
      } else {
        button.closest('[data-product-grid-load-more-container]')?.remove();
      }

      const currentState = {
        ...(history.state || {}),
        page: Number(nextUrl.searchParams.get('page')) || 1,
        gridHeight: productGrid.scrollHeight,
        scrollPosition: window.scrollY,
        searchParams: nextUrl.search.slice(1),
        productGridLoadMore: true,
      };

      history.pushState(currentState, '', `${nextUrl.pathname}${nextUrl.search}`);

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(productGrid);
      }
    } catch (error) {
      console.error(error);
      window.location.assign(nextUrl.href);
    }
  });

  function setLoading(button, isLoading) {
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', String(isLoading));
    button.setAttribute('aria-disabled', String(isLoading));
  }
}
